import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconPenSharp = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m17.082 4.293-.707-.707-.707.707-10.5 10.5-.196.196-.068.269-.875 3.5-.404 1.617 1.617-.405 3.5-.875.269-.067.196-.196 10.5-10.5.707-.707-.707-.707-2.625-2.625ZM6.374 17.626l.404-1.615 9.597-9.597 1.21 1.211-9.597 9.597-1.614.404ZM13 18h-1v2h8v-2h-7Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconPenSharp);
export default Memo;
